import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { Grafico } from '../Home.styles';

export const AverageDaysValueChart = ({ averageDaysValue }: { averageDaysValue: number }) => {
  const averageDaysData = [{ value: 3 }, { value: 3 }, { value: 9 }];

  const colorsRed = ['#5cb85c', '#ffeb3b', '#d9544f'];

  const RADIAN = Math.PI / 180;

  const cx = 250;
  const cy = 270;
  const iR = 90;
  const oR = 180;

  const needle = (
    value: number,
    averageDays: any[],
    cx: number,
    cy: number,
    iR: number,
    oR: number,
    COLORS: string | any[],
  ) => {
    let total = 0;

    averageDaysData.forEach(v => {
      total += v.value;
    });

    const ang = 180.0 * (1 - value / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 5;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return [
      <circle key={1} cx={x0} cy={y0} r={r} fill={'#7f8790'} stroke="none" />,
      <path key={2} d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={'#7f8790'} />,
    ];
  };

  return (
    <Grafico>
      <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
          Média de dias por documento
        </p>
        <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
          Duração média dos documentos (dias)
        </span>
      <PieChart width={520} height={360}>
        
        <Pie
          dataKey="value"
          startAngle={180}
          endAngle={0}
          data={averageDaysData}
          cx={cx}
          cy={cy}
          innerRadius={iR}
          outerRadius={oR}
          stroke="none"
          // label={({ name, value }) => `${name}: ${value}`}
        >
          {averageDaysData?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colorsRed[index % colorsRed?.length]} />
          ))}
        </Pie>
        {needle(averageDaysValue, averageDaysData, cx, cy, iR, oR, '')}
        <Tooltip />
      </PieChart>
      <h3>{`Média: ${averageDaysValue}`}</h3>
    </Grafico>
  );
};
